import { render, staticRenderFns } from "./WorkplaceDueDateRulesForm.vue?vue&type=template&id=4c6ee56a&"
import script from "./WorkplaceDueDateRulesForm.vue?vue&type=script&lang=js&"
export * from "./WorkplaceDueDateRulesForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkplaceDueDateRulesForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports